import { isNull, recipe } from "@mealplan/powersync";

/**
 * ┌─────────────────────────────────────────────────────────────────────────┐
 * │ SOFT-DELETE — CENTRALIZED LIVE LAYER (single choke point)                  │
 * └─────────────────────────────────────────────────────────────────────────┘
 *
 * This module is the ONLY place where the "live row = `deleted_at IS NULL`"
 * invariant is expressed for this repo's tables with a trash flow (`recipe`).
 * Every live read composes these predicates (the domain builders in
 * recipes/meal-plan/shopping import them from here). The ONLY reads that see
 * deleted rows are the trash (`getTrashedRecipesQuery`), the activity feed name
 * resolver (which legitimately displays names of already-deleted recipes),
 * and occasional harmless id-scoped lookups, all declared in the guard
 * whitelist (`guard-manifest.ts`).
 *
 * Why centralize? The scattered invariant was the #1 bug family of the
 * campaign (stats/counters/joins/PATCH that ignored `deleted_at`). With a
 * single choke point + anti-regression guard, adding a raw read of these tables
 * outside the whitelist BREAKS the build (see
 * `live/__tests__/live-access-guard.test.ts`).
 *
 * Schema NOTE (meal-planner): only `recipe` has `deleted_at`.
 * `recipe_ingredient` is NOT soft-delete: it is an FK cascade child (`ON DELETE
 * cascade`) and remains intact while the recipe is in the trash (it reappears
 * on restore) and is removed when its parent `recipe` is purged.
 */

/**
 * "Live recipe" predicates: the recipe is not in the trash. Applies to EVERY
 * live view/query for `recipe`. `recipe` has no parent with a trash flow, so its
 * own `deleted_at IS NULL` is sufficient.
 */
export function liveRecipeFilters() {
  return [isNull(recipe.deleted_at)];
}
